module.exports = __webpack_public_path__ + "static/media/Retail.2383ec0e.svg";